module.exports = __webpack_public_path__ + "img/IMG_0204-15_L_Black.f0a290b2.jpg";